<style scoped>
.compare-indice {
  color: #999;
  font-size: 12px;
  margin: 0 5px;
}
</style>

<template lang="pug">
div.multiIndicesMenu
  v-select(
    v-model="customIndice",
    :options="indicesMenuNoEmpty"
    )
  em.compare-indice 对比
  v-select(
    v-model="twoIndice",
    :options="indicesMenuNoCustom",
    :disabled="twoIndiceDisabled"
    )
</template>

<script>
/* global _ */
export default {
  props: {
    indicesMenu: Array,
    compared: {
      type: Boolean,
      default: false
    },
    indice: String,
    compIndice: String,
    twoIndiceShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customIndice: this.indice || this.indicesMenu[1].value,
      twoIndice: this.compIndice || this.indicesMenu[0].value
    }
  },
  computed: {
    twoIndiceDisabled () {
      return this.compared || !this.twoIndiceShow
    },
    indicesMenuNoEmpty () {
      const indicesMenu = _.cloneDeep(this.indicesMenu)
      return indicesMenu.map(item => {
        item.disabled = item.value === this.twoIndice && !this.twoIndiceDisabled
        return item
      }).filter(i => i.value !== '_')
    },
    indicesMenuNoCustom () {
      const indicesMenu = _.cloneDeep(this.indicesMenu)
      return indicesMenu.map(item => {
        item.disabled = item.value === this.customIndice && !this.twoIndiceDisabled
        return item
      })
    }
  },
  watch: {
    indice () {
      this.customIndice = this.indice !== '' ? this.indice : this.indicesMenu[1].value
    },
    compIndice () {
      this.twoIndice = this.compIndice
    },
    customIndice (newVal, oldVal) {
      if (newVal === this.twoIndice) {
        this.customIndice = oldVal
      } else {
        this.$nextTick(() => {
          this.indiceChange()
        })
      }
    },
    twoIndice (newVal, oldVal) {
      if (newVal === this.customIndice) {
        this.twoIndice = oldVal
      } else {
        this.$nextTick(() => {
          this.indiceChange()
        })
      }
    }
  },
  methods: {
    indiceChange () {
      this.$emit('indiceChange', {
        customIndice: this.customIndice,
        twoIndice: this.twoIndice
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// indiceCompare.vue?1becb662